import TextInputWithValidate, { TextInputWithValidateProps } from './text-input-with-validate';

export type DateTimeWithValidateProps<T = {}> = TextInputWithValidateProps<T> & {};

function DateTimeWithValidate<T>({ ...props }: DateTimeWithValidateProps<T>) {
  return (
    <TextInputWithValidate<T>
      type="datetime-local"
      InputLabelProps={{
        shrink: true,
      }}
      {...props}
    />
  );
}

export default DateTimeWithValidate;
